import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ArrowIcon } from "assets/icons/left-arrow.svg";
import "./payment-styles.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const paymentId =
    searchParams.get("collection_id") || searchParams.get("payment_id");
  const paymentType = searchParams.get("payment_type");
  const status = searchParams.get("collection_status");
  const externalReference = searchParams.get("external_reference");
  const currentDate = new Date().toLocaleDateString("es-CO", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <article className="container-payments-centered">
      <section className="form-container">
        <div className="payment-invoice-card">
          <div className="invoice-header">
            <span className="invoice-badge">Comprobante de Pago</span>
            <h2>Grupo Alianza Colombia</h2>
            <p className="invoice-date">{currentDate}</p>
          </div>

          <div className="invoice-body">
            <div className="invoice-row">
              <span className="invoice-label">ID de Transacción:</span>
              <span className="invoice-value">{paymentId || "N/A"}</span>
            </div>
            <div className="invoice-row">
              <span className="invoice-label">Referencia / Contrato:</span>
              <span className="invoice-value">
                {externalReference || "N/A"}
              </span>
            </div>
            <div className="invoice-row">
              <span className="invoice-label">Método de Pago:</span>
              <span className="invoice-value uppercase">
                {paymentType || "Mercado Pago"}
              </span>
            </div>
            <div className="invoice-row">
              <span className="invoice-label">Estado:</span>
              <span className="invoice-value status-approved">
                {status ? status.toUpperCase() : "APROBADO"}
              </span>
            </div>
          </div>

          <div className="invoice-actions">
            <button
              className="btn-invoice-print"
              onClick={() => window.print()}
            >
              Imprimir Comprobante
            </button>

            <button className="btn-back-step" onClick={() => navigate("/")}>
              <ArrowIcon />
              Finalizar y Volver
            </button>
          </div>
        </div>
      </section>
    </article>
  );
};

export default PaymentSuccess;
